import { render, staticRenderFns } from "./TableRowBinauralRate.vue?vue&type=template&id=c64802d0&lang=pug&"
import script from "./TableRowBinauralRate.vue?vue&type=script&lang=js&"
export * from "./TableRowBinauralRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c64802d0')) {
      api.createRecord('c64802d0', component.options)
    } else {
      api.reload('c64802d0', component.options)
    }
    module.hot.accept("./TableRowBinauralRate.vue?vue&type=template&id=c64802d0&lang=pug&", function () {
      api.rerender('c64802d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/audiology-kpis/benchmarks/table-rows/TableRowBinauralRate.vue"
export default component.exports